import { GoogleAnalyticsScript } from './GoogleAnalyticsScript';
import { GA_ID_WEBVIEW } from './constants';

// 매니저앱, 유저앱의 웹뷰 기반으로 작성될 웹은 이걸로 수집함.
export const GoogleAnalyticsWebviewScript = () => {
  return <>
    <GoogleAnalyticsScript gaId={GA_ID_WEBVIEW} />
  </>;
};